import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: a = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const v = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ e.createElement(h, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-heyuegendan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-åçº¦è·å"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? d(o, 0, "#262933") : "#262933",
        datafollowfill: c ? d(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.1 20.5a.9.9 0 0 1 .9-.9h9a.9.9 0 1 1 0 1.8h-9a.9.9 0 0 1-.9-.9Zm10.611-8.449a.9.9 0 0 0-1.422-1.102l-2.222 2.866a.068.068 0 0 1-.046.023.073.073 0 0 1-.054-.014l-1.758-1.383-.007-.005a1.867 1.867 0 0 0-2.62.335l-2.295 2.978a.9.9 0 1 0 1.426 1.099l2.293-2.976a.068.068 0 0 1 .094-.013l1.759 1.384.006.005a1.875 1.875 0 0 0 2.615-.318l.005-.007 2.226-2.872Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.695 7.407A3.407 3.407 0 0 1 12.103 4h12.489a3.407 3.407 0 0 1 3.407 3.407v17.186A3.407 3.407 0 0 1 24.592 28H9.41a.906.906 0 0 1-.161.013A5.265 5.265 0 0 1 8.936 28h-.24v-.022a5.205 5.205 0 0 1-4.596-5.17v-6.036a2.604 2.604 0 0 1 2.604-2.604h1.991v-6.76ZM12.103 5.8h12.489c.887 0 1.607.72 1.607 1.607v17.186c0 .887-.72 1.607-1.607 1.607H10.495V7.407c0-.887.72-1.607 1.608-1.607ZM8.695 15.968H6.704a.804.804 0 0 0-.804.804v6.037a3.405 3.405 0 0 0 2.795 3.35v-10.19Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
